export const playerPageDateFormat = "MM/DD/yyyy hh:mm A";
